import React, { useState, useEffect } from 'react';
import ReactStrapTable from 'components/reactStrapTable';
import { currencyFormat, cellRendererCheck } from 'utils/columns';
import { useNavigate } from 'react-router-dom';

import useAxios from 'hooks/useAxios';

const TaskBoardTable = (props) => {
    const { orgId } = props;
    const API = useAxios();
    const navigate = useNavigate();
    const [taskBoardData, setTaskBoardData] = useState([]);

    const handleProviderResearchClick = (ceId) => {
        window.selectedCoveredEntittyId = ceId;
        navigate(`/providers`);
    }

    const handleLocationResearchClick = (ceId) => {
        window.selectedCoveredEntittyId = ceId;
        navigate(`/location`);
    }

    const handleFaxToBeMapperClick = (ceId) => {
        window.selectedCoveredEntittyId = ceId;
        window.selectedFaxDirection = "190001";
        window.selectedFaxStatus = "180004";
        navigate(`/fax`);
    }

    const formatter = (row, action) => {
        if (action === "provider") {
            if (row.providerResearchRequired) {
                return (
                    <span
                        className='cursor-pointer text-decoration-underline'
                        onClick={() => handleProviderResearchClick(row.coveredEntityID)}
                    >
                        {row.providerResearchRequired}
                    </span>
                );
            }
            else {
                return (
                    <span>-</span>
                );
            }

        }
        else if (action === "location") {
            if (row.locationResearchRequired) {
                return (
                    <span
                        className='cursor-pointer text-decoration-underline'
                        onClick={() => handleLocationResearchClick(row.coveredEntityID)}
                    >
                        {row.locationResearchRequired}
                    </span>
                );
            }
            else {
                return (
                    <span>-</span>
                );
            }
        }
        else if (action === "faxtobemapped") {
            if (row.faxToBeMapped) {
                return (
                    <span
                        className='cursor-pointer text-decoration-underline'
                        onClick={() => handleFaxToBeMapperClick(row.coveredEntityID)}
                    >
                        {row.faxToBeMapped}
                    </span>
                );
            }
            else {
                return (
                    <span>-</span>
                );
            }
        }


    };


    let taskBoardColumns = [
        {
            dataField: 'coveredEntityName',
            text: 'Covered Entity Name',
            sort: true,
            width: 144,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => cellRendererCheck(row.coveredEntityName),
            edit: false,
        },
        {
            dataField: 'providerResearchRequired',
            text: 'Provider Research Required',
            sort: false,
            width: 144,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => formatter(row, "provider"),
            edit: false,
        },
        {
            dataField: 'opportunityCount',
            text: 'Opportunity Count',
            sort: false,
            width: 144,
            show: true,
            inputType: 'text',
            cellRenderer: (row, col) => cellRendererCheck(row.opportunityCount),
            edit: false,
        },
        {
            dataField: 'opportunityAmount',
            text: 'Opportunity Amount',
            sort: false,
            width: 144,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => currencyFormat(row.opportunityAmount),
            edit: false,
        },
        {
            dataField: 'locationResearchRequired',
            text: 'Location Research Required',
            sort: false,
            width: 144,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => formatter(row, "location"),
            edit: false,
        }
        ,
        {
            dataField: 'faxToBeMapped',
            text: 'Fax To Be Mapped',
            sort: false,
            width: 144,
            show: true,
            inputType: 'text',
            cellRenderer: (row) => formatter(row, "faxtobemapped"),
            edit: false,
        }
    ];

    useEffect(() => {
        fetchTaskBoardData();
    }, [orgId]);


    const fetchTaskBoardData = async () => {
        try {
            const { data } = await API.get(
                `Dashboard/RVRVTFIvVnJBckVuY3hQZ285ZHc1Zz09/Taskboard/All/${orgId?.organizationID}`);

            setTaskBoardData(data)

        } catch (error) {

        }
    };

    return (
        <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'
            fixed-height={taskBoardData.length > 0 ? 'fixed-height' : 'default'}
        >
            <ReactStrapTable
                id='invoicedetail-table'
                fixedColumn
                data={taskBoardData}
                columns={taskBoardColumns}
                gridMsg="Great Job! There are no pending tasks"
            />
        </div>
    );
};

export default TaskBoardTable;